export var defaultProps = {
    className: '',
    style: undefined,
    separator: '/',
};
export var defaultItemProps = {
    className: '',
    style: undefined,
    href: '',
    separator: '/',
};
